<template>
  <div
    class="main-title"
    :class="{ 'main-title--yellow-backdrop': yellowBackdrop }"
  >
    <h2 class="main-title__title">
      {{ pageTitle }}
      <span v-if="yellowBackdrop" class="main-title__backdrop"></span>
    </h2>
  </div>
</template>

<script>
export default {
  name: 'MainTitle',
  props: {
    pageTitle: {
      type: String,
      required: true,
    },
    yellowBackdrop: Boolean,
  },
};
</script>
